const colors = {
  marineBlue: '#02435d',
  azure: '#1ca7e5',
  seafoamBlue: '#65d7c8',
  grapeFruitTwo: '#f56c6c',
  white: '#ffffff',
  salmonThree: '#ff8080',
  paleRed: '#e24d4d',
  veryLightPink: '#d8d8d8',
  black: '#000000',
  shamrock: '#02b948',
  iceBlueTwo: '#fafeff',
  salmonTwo: '#ff7d7c',
};
export default colors;
